var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImageThumbnail',_vm._b({staticClass:"file-preview",class:{ placeholder: !_vm.fileUrl },attrs:{"name":_vm.fileName,"url":_vm.fileUrl || _vm.fileObjectUrl}},'ImageThumbnail',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }